import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import { FaListUl, FaWallet } from "react-icons/fa";
import { FaRegMoneyBill1 } from "react-icons/fa6";
import { TbReportAnalytics } from "react-icons/tb";

import { CheckPermission } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString } from "../../helper/Components";
import { isUsraRole } from "../../helper/Method";
import { isFundsReportUnitType } from "./shared/fundsReportUnit";

const QuickFundReports = ({ history }) => {
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const canViewFundsReport =
    CheckPermission("CanViewFundsReport") || CheckPermission("CanViewFunds");
  const showFundsReports =
    canViewFundsReport && isFundsReportUnitType(unitTypeName);
  const showCashBalanceReport = canViewFundsReport && !isUsraRole();

  return (
    <div className="wrapper wrapper-content wrapper-custom">
      <div className="ibox">
        <div className="ibox-content panel-body">
          <h3>{<GetLanguageString props="quick_reports_heading" />}</h3>
          <p>{<GetLanguageString props="quick_reports_message" />}</p>
          <Row>
            <Col xl="1" className="text-center">
              <Button
                className="btn-primary dim btn-large-dim"
                onClick={() =>
                  history.push({
                    pathname: `/infaqreport`,
                  })
                }
              >
                <FaRegMoneyBill1 size={50} />
              </Button>
              <h4>
                {<GetLanguageString props="quick_fund_reports_infaq" />}
              </h4>
            </Col>
            {showFundsReports ? (
            <Col xl="1" className="text-center">
              <Button
                className="btn-warning dim btn-large-dim"
                onClick={() =>
                  history.push({
                    pathname: `/fundReports/expense`,
                  })
                }
              >
                <FaListUl />
              </Button>
              <h4>
                {<GetLanguageString props="quick_fund_reports_expense" />}
              </h4>
            </Col>
            ) : null}
            {showFundsReports ? (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-success dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/fundReports/income`,
                    })
                  }
                >
                  <TbReportAnalytics size={50} />
                </Button>
                <h4>
                  {<GetLanguageString props="quick_fund_reports_income" />}
                </h4>
              </Col>
            ) : null}
            {showCashBalanceReport ? (
              <Col xl="1" className="text-center">
                <Button
                  className="btn-info dim btn-large-dim"
                  onClick={() =>
                    history.push({
                      pathname: `/fundReports/cashBalance`,
                    })
                  }
                >
                  <FaWallet size={50} />
                </Button>
                <h4>
                  {<GetLanguageString props="quick_fund_reports_cash_balance" />}
                </h4>
              </Col>
            ) : null}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default withRouter(QuickFundReports);
